import * as React from 'react';
import { ClickAwayListener, Collapse, MenuItem, MenuList, Paper, Portal, withStyles } from '@material-ui/core';
import { Manager, Target, Popper } from 'react-popper';
import classNames from 'classnames';
import WarningIcon from '@markinson/uicomponents-v2/SvgIcons/Warning';
import styles from './styles';
import { useLongPress, useSinglePress } from 'utils/hooks';

const LinkItemWithMenu = (props) => {
    const { id, label, actionList, enableMenuLogic, showWarning, clickHandler, classes } = props;

    const actions = React.useMemo(() => (actionList?.filter((item) => !item.label.includes('Customer Maintenance'))), [actionList]);

    const [openMenu, setOpenMenu] = React.useState(false);
    const [longPress, setLongPress] = React.useState(false);

    const { onMouseDown, onMouseUp, onTouchStart, onTouchEnd } = useLongPress(
        () => {
            setLongPress(true);
            setOpenMenu(true);
        },
        () => setLongPress(false)
    );

    const { onMouseUp: handleSinglePress } = useSinglePress(() => {

        if (!longPress) {
            actions?.[0]?.action(actions?.[0]?.actionParam || '');
        }
    });

    const handleMouseUp = (event) => {
        handleSinglePress(event);
        onMouseUp();
    };

    const handleClose = () => {
        setOpenMenu(false);
        setLongPress(false);
    };

    const infoIconAction = (item: any) => () => item.action(item.actionParam || '');

    const handleContextMenu = (event) => {
        event.preventDefault();
        setLongPress(true);
        setOpenMenu(true);
    };

    return (
        <>
            <div className={classes.splitCellContainer}>
                {
                    enableMenuLogic ? (
                        <Manager>
                            <Target>
                                <ClickAwayListener onClickAway={handleClose}>
                                    <div
                                        className={classes.splitCellContent}
                                        onMouseDown={onMouseDown}
                                        onMouseUp={handleMouseUp}
                                        onTouchStart={onTouchStart}
                                        onTouchEnd={onTouchEnd}
                                        onContextMenu={handleContextMenu}
                                    >
                                        {id && (
                                            <>
                                                <span>{id}</span>
                                                <br />
                                            </>
                                        )}
                                        <span>{label}</span>
                                    </div>
                                </ClickAwayListener>
                            </Target>
                            <Portal>
                                <Popper
                                    placement='bottom-start'
                                    eventsEnabled={openMenu}
                                    className={classNames({ [classes.popperClose]: !openMenu })}
                                    style={{ zIndex: 5 }}
                                >
                                    <Collapse in={openMenu}>
                                        <Paper style={{ margin: 3, backgroundColor: '#eeeeee' }}>
                                            <MenuList role='menu'>
                                                {
                                                    actions && actions?.map((item: { id: string | undefined; label: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined }, index: React.Key | undefined) => (
                                                        <MenuItem
                                                            key={index}
                                                            id={item.id}
                                                            onClick={infoIconAction(item)}
                                                        >
                                                            {item.label}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </MenuList>
                                        </Paper>
                                    </Collapse>
                                </Popper>
                            </Portal>
                        </Manager>
                    ) : (
                        <span>{label}</span>
                    )
                }
                <div className={classes.splitCellAction}>
                    {showWarning && <WarningIcon
                        className={classes.iconWarning}
                        onClick={clickHandler} />}
                </div>
            </div>
        </>
    );
};

export default withStyles(styles, { index: 1 })(LinkItemWithMenu);
